import { Injectable } from '@angular/core';
import { Store } from 'src/app/core/services/store.service';
import { ScreenSize } from '../models/screen-size.model';
import { BreakpointObserver, BreakpointState, MediaMatcher } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeStoreService extends Store<ScreenSize> {

  private customBreakpoints = {
    xs: '(max-width: 600.98px)',
    s: '(min-width: 601px) and (max-width: 960.98px)',
    m: '(min-width: 961px) and (max-width: 1280.98px)',
    l: '(min-width: 1280px) and (max-width: 1920.98px)',
    xl: '(min-width: 1921px)',
  };

  constructor(private breakpointObserver: BreakpointObserver, private mediaMatcher: MediaMatcher) {
    super(null);
    this.setScreenSizeOnLoad();
    this.breakpointObserver.observe([
      this.customBreakpoints.xs,
      this.customBreakpoints.s,
      this.customBreakpoints.m,
      this.customBreakpoints.l,
      this.customBreakpoints.xl,
    ]).subscribe((state: BreakpointState) => {
      if (state.breakpoints[this.customBreakpoints.xs]) {
        this.setState(ScreenSize.XS);
      } else if (state.breakpoints[this.customBreakpoints.s]) {
        this.setState(ScreenSize.S);
      } else if (state.breakpoints[this.customBreakpoints.m]) {
        this.setState(ScreenSize.M);
      } else if (state.breakpoints[this.customBreakpoints.l]) {
        this.setState(ScreenSize.L);
      } else if (state.breakpoints[this.customBreakpoints.xl]) {
        this.setState(ScreenSize.XL);
      }
    });
  }

  public getState() {
    return this.state$;
  }

  private setScreenSizeOnLoad() {
    var size = ScreenSize.XL;

    if (this.mediaMatcher.matchMedia(this.customBreakpoints.xs).matches) {
      size = ScreenSize.XS;
    } else if (this.mediaMatcher.matchMedia(this.customBreakpoints.s).matches) {
      size = ScreenSize.S;
    } else if (this.mediaMatcher.matchMedia(this.customBreakpoints.m).matches) {
      size = ScreenSize.M;
    } else if (this.mediaMatcher.matchMedia(this.customBreakpoints.l).matches) {
      size = ScreenSize.L;
    }
    this.setState(size);

  }

}
